// Helper para centralizar el manejo y dispatch de errores en Redux
import errorTrackingFromCMS from '../../scripts/analytics/creators/error';
import { sendAnalytics } from '../../scripts/analytics/tracker';

export function handleError(dispatch, error, options = {}) {
  const {
    statusCode = 503,
    code = 'GENERIC_ERROR',
    actionable = 'ABORT',
    actionType = 'GENERIC_ACTION',
    errorMsg,
    errorExtraInfo,
    failAction,
  } = options;

  if (failAction) {
    dispatch(failAction(error));
  }

  dispatch(sendAnalytics({
    eventCreator: errorTrackingFromCMS.errorFromCMS({
      type: 'Fatal',
      statusCode,
      code,
      actionable,
      actionType,
      errorMsg: errorMsg || error.message,
      errorExtraInfo: errorExtraInfo || error.stack || 'Error no especificado',
    }),
  }));
}
